<template>
  <div v-loading="loading" class="public-View">
    <div class="public-goback">
      <!-- <img alt :src="g_imgSrc.rightArrow" class="public-goback-img" @click="goback" />
      <div class="public-goback-return" @click="goback">返回</div> -->
    </div>
    <div class="public">
      <el-form
        ref="form"
        class="form_box"
        :model="form"
        :rules="rules"
        label-width="160px"
        label-position="left"
      >
        <el-form-item label="姓名：" prop="name">
          <el-input v-model.trim="form.name" placeholder="请输入姓名" :maxlength="10" clearable />
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input
            v-model.trim="form.phone"
            placeholder="请输入手机号"
            :maxlength="11"
            clearable
          />
        </el-form-item>
        <el-form-item label="邮箱：" prop="email" v-if="loginType === 3">
          <el-input v-model.trim="form.email" placeholder="请输入邮箱" clearable />
        </el-form-item>
        <el-form-item label="微信号：" prop="WeChat">
          <el-input
            v-model.trim="form.WeChat"
            placeholder="请输入微信号"
            :minlength="6"
            :maxlength="20"
            clearable
          />
        </el-form-item>
        <el-form-item label="企业微信id：" prop="qyUserId" v-if="loginType === 2">
          <el-input
            v-model.trim="form.qyUserId"
            placeholder="请输入企业微信号"
            :maxlength="20"
            clearable
          />
        </el-form-item>
        <el-form-item label="角色：" prop="role">
          <el-select v-model="form.role" :clearable="true" @change="changeRole">
            <!-- <el-option
              v-for="item in characterList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
              :disabled="item.count >= item.total && form.role !== 1"
            >
              {{ item.label + `(${item.count}/${item.total})` }}
            </el-option> -->
            <el-option
              v-for="item in characterLists"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
              {{ item.Name }}
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公众号权限：" prop="publistValue" v-if="form.role === 1">
          <el-input placeholder="请输入内容" value="全部权限" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="公众号权限：" v-else prop="publistValue" class="select-line">
          <el-select v-model="form.publistValue" multiple class="select_all_show">
            <div class="select_btn_col">
              <span @click="selectPublicText(false)">取消</span>
              <span @click="selectPublicText(true)">全选</span>
            </div>
            <el-option
              v-for="(item, index) in publicList"
              :key="index"
              :label="item.app_name"
              :value="item.app_id"
              class="AuthorityListoption"
              :disabled="+item.status === 2"
            >
              <span>{{ item.app_name || '--' }}</span>
            </el-option>
          </el-select>
          <div class="select_hint">可多选</div>
        </el-form-item>
        <el-form-item label="企业应用权限：" prop="agentValue" v-if="form.role === 1">
          <el-input placeholder="请输入内容" value="全部权限" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="企业应用权限：" v-else prop="agentValue" class="select-line">
          <el-select v-model="form.agentValue" multiple class="select_all_show">
            <div class="select_btn_col">
              <span @click="selectAgentText(false)">取消</span>
              <span @click="selectAgentText(true)">全选</span>
            </div>
            <el-option
              v-for="(item, index) in agentList"
              :key="index"
              :label="item.agent_name"
              :value="item.agent_id"
              class="AuthorityListoption"
              :disabled="+item.close === 1"
            >
              <span>{{ item.agent_name || '--' }}</span>
            </el-option>
          </el-select>
          <div class="select_hint">可多选</div>
        </el-form-item>
        <div class="save_button">
          <el-button type="primary" @click="handleSubmit('form')" class="pubic-button">
            保存
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  addManagerInfoApi,
  getAppManagerCountApi,
  getManagerInfoApi,
  updateManagerInfoApi,
  GetManagerUserGroup,
} from '@/api/setUser';

import { getAppList } from '@/api/dataCenter';
import { EyaoSaasGetAppInfoList } from '@/api/enterpriseWeChatManagement';
export default {
  name: 'ManagerDetails',
  data() {
    return {
      loading: false, // 加载状态
      form: {
        name: null, // 公共号名称
        phone: null, // 手机号
        email: null, // 邮箱
        WeChat: null, // 微信
        role: null, // 角色信息
        publistValue: [], // 公众号
        agentValue: [], // 企业应用
        qyUserId: '', // 企业微信id
      },
      // 管理员 操作员列表
      characterList: [
        {
          id: 1,
          label: '管理员',
          disabled: false,
          total: 3,
          count: 0,
        },
        {
          id: 2,
          label: '操作员',
          total: 99,
          disabled: false,
          count: 0,
        },
      ],
      characterLists: [],
      // 校验规则
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          {
            min: 1,
            max: 10,
            message: '请输入长度在 1 到 10 个字',
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: '请输入正确的手机号', trigger: 'blur' },
          {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号格式不正确',
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, message: '请输入正确的邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9]+([_.][A-Za-z0-9]+)*@([A-Za-z0-9-]+\.)+[A-Za-z]{2,6}$/,
            message: '邮箱格式不正确',
            trigger: 'blur',
          },
        ],
        WeChat: [
          {
            required: true,
            message: '请输入以字母开头，6-20位',
            trigger: 'blur',
          },
          {
            pattern: /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/,
            message: '请输入以字母开头，6-20位',
            trigger: 'blur',
          },
        ],
        role: [
          {
            required: true,
            message: '请选择角色',
            trigger: 'change',
          },
        ],
        qyUserId: [
          {
            required: false,
            message: '请输入企业微信号',
            trigger: 'change',
          },
        ],
      },
      id: this.$route.query.id,
      publicList: [],
      agentList: [],
      loginType: 1, // 登录方式，1手机号，2企微，3 okta
    };
  },
  computed: {
    // 是否编辑操作
    isEdit() {
      return !!this.id;
    },
    // 缓存企业应用列表
    enterprise_id() {
      return this.$store.state.user.managerLogin.enterprise_id;
    },
  },
  async created() {
    this.$store
      .dispatch('login/getLoginConfig')
      .then((res) => {
        console.log(res);
        this.loginType = res.login_type;
        this.rules.qyUserId[0].required = this.loginType === 2;
        this.rules.email[0].required = this.loginType === 3;
      })
      .catch((e) => this.$message.error(e));
    // 公众号列表
    this.publicList = (
      await getAppList({ page_index: 1, page_size: 9999, enterprise_id: `${this.enterprise_id}` })
    ).list;
    // 角色列表
    this.characterLists = (await GetManagerUserGroup()).GroupList;
    // 企业应用列表
    this.agentList = (await EyaoSaasGetAppInfoList({ page_index: 1, page_size: 9999 })).list;
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      const breadcrumb = [
        { menu_name: '设置', menu_path: '' },
        { menu_name: '管理员设置', menu_path: 'setManager' },
      ];
      let menuName = '新增管理员';
      this.getManageNumber();
      if (this.isEdit) {
        menuName = '编辑管理员';
        this.getManagerInfo();
      }
      breadcrumb.push({ menu_name: menuName });
      this.g_breadcrumb(breadcrumb);
    },
    // 管理员数量
    getManageNumber() {
      getAppManagerCountApi()
        .then((res) => {
          res.list.forEach((e) => {
            const keyData = {
              1: 0,
              2: 1,
            };
            try {
              this.$set(this.characterList[keyData[e.role]], 'count', e.count);
            } catch (e) {
              console.log(e);
            }
          });
        })
        .catch(() => {
          this.$message.error('查询失败-管理员数量');
        });
    },
    // 获取管理员详细信息
    getManagerInfo() {
      this.loading = true;
      getManagerInfoApi({ id: Number(this.id) })
        .then((res) => {
          this.loading = false;
          this.form.role = res.role;
          this.form.name = res.name;
          this.form.phone = res.phone;
          this.form.email = res.email;
          this.form.WeChat = res.wxid;
          this.form.publistValue = res.app_list ? res.app_list.map((item) => item.app_id) : [];
          this.form.agentValue = res.agent_list ? res.agent_list.map((item) => item.agent_id) : [];
          this.form.qyUserId = res.qy_user_id;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error(error.message);
        });
    },
    // 保存
    handleSubmit(formName) {
      const _this = this;
      _this.$refs[formName].validate((valid) => {
        if (valid) {
          const form = {
            name: _this.form.name,
            phone: _this.form.phone,
            email: _this.form.email,
            wxid: _this.form.WeChat,
            role: _this.form.role,
            app_list: _this.form.publistValue,
            agent_list: _this.form.agentValue,
            qy_user_id: _this.form.qyUserId,
          };
          // 如果是管理员, 返回所有绑定的数据, 包括已禁用的数据
          if (_this.form.role === 1) {
            form.app_list = [
              ..._this.form.publistValue,
              ..._this.publicList.map((item) => item.app_id),
            ];
            form.agentValue = [
              ..._this.form.agentValue,
              ..._this.agentList.map((item) => item.agent_id),
            ];
          } else if (_this.form.role === 2) {
            if (!form.app_list.length && !form.agent_list.length) {
              _this.$message.warning('公众号或企业应用至少选择一个');
              return;
            }
          }
          if (!!_this.id) {
            _this.updateManagerInfo(form);
          } else {
            _this.addManagerInfo(form);
          }
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },
    // 新增
    addManagerInfo(form) {
      this.loading = true;
      addManagerInfoApi(form)
        .then(() => {
          this.$message.success('新增成功');
          this.goback();
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
      this.loading = false;
    },
    // 更新
    updateManagerInfo(form) {
      this.loading = true;
      const formTemp = { ...form, id: this.id };
      updateManagerInfoApi(formTemp)
        .then(() => {
          this.$message.success('编辑成功');
          this.goback();
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
      this.loading = false;
    },
    // 公众号 全选|取消
    selectPublicText(flag) {
      if (flag) {
        const arr = [];
        this.publicList.forEach((item) => {
          if (item.status === 1) {
            arr.push(item.app_id);
          }
        });
        this.form.publistValue = arr;
      } else {
        this.form.publistValue = [];
      }
    },
    // 企业应用 全选|取消
    selectAgentText(flag) {
      if (flag) {
        const arr = [];
        this.agentList.forEach((item) => {
          if (item.close === 0) {
            arr.push(item.agent_id);
          }
        });
        this.form.agentValue = arr;
      } else {
        this.form.agentValue = [];
      }
    },
    // 改变角色
    changeRole() {
      this.form.publistValue = [];
      this.form.agentValue = [];
    },
    // 返回
    goback() {
      this.$emit('changeComponet', 'managerList');
    },
  },
};
</script>
<style scoped lang="scss">
.public-View {
  width: 100%;
  // height: 100%;
  // padding: 0 24px;
  position: relative;
  overflow: auto;
  .public-goback {
    position: relative;
    // height: 80px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #303133;
    .public-goback-img {
      position: absolute;
      top: 32.5px;
      left: 0;
      width: 24px;
      height: 24px;
      transform: rotateY(180deg);
    }
    .public-goback-return {
      position: absolute;
      top: 37px;
      width: 44px;
      height: 22px;
      left: 28px;
      font-family: PingFangSC-Regular;
      font-size: 16px;
      color: #606266;
      letter-spacing: 0;
      cursor: pointer;
    }
    .public-goback-return:hover {
      color: rgb(47, 150, 255);
    }
  }
}
::v-deep.form_box {
  margin-top: 50px;
  .el-form-item {
    .el-form-item__label {
      height: 48px;
      line-height: 48px;
      color: #303133;
      letter-spacing: 0;
      font-size: 16px;
      font-weight: 700;
    }
    .el-input {
      width: 600px !important;
    }
  }
  .select-line {
    .el-form-item__content {
      display: flex;
      .select_hint {
        margin-left: 20px;
        font-size: 14px;
        color: #909399;
      }
    }
  }
}
.select_btn_col {
  text-align: right;
  padding: 10px 20px;
  > span {
    padding-left: 10px;
    &:hover {
      color: #2f96ff;
      cursor: pointer;
    }
  }
}
.save_button {
  margin-top: 50px;
  text-align: center;
  > .el-button {
    width: 216px;
  }
}
</style>
